/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var a;!function(a){a[a.Horizontal=0]="Horizontal",a[a.Vertical=1]="Vertical",a[a.Cross=2]="Cross",a[a.ForwardDiagonal=3]="ForwardDiagonal",a[a.BackwardDiagonal=4]="BackwardDiagonal",a[a.DiagonalCross=5]="DiagonalCross",a[a.COUNT=6]="COUNT"}(a||(a={}));export{a as Style};
